import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/service/api.service';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-informative',
  templateUrl: './informative.component.html',
  styleUrls: ['./informative.component.css']
})
export class InformativeComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  itemTm!: any;
  itemTmValidation!: any;
  itemTmSplit!: any;
  itemTmTooltip!: any;
  itemTmLastYear!: any;

  itemPmpv!: any;
  itemPmpvValidation!: any;
  itemPmpvSplit!: any;
  itemPmpvTooltip!: any;
  itemPmpvLastYear!: any;

  itemPa!: any;
  itemPaValidation!: any;
  itemPaSplit!: any;
  itemPaTooltip!: any;
  itemPaLastYear!: any;

  itemTotal!: any;
  itemTotalValidation!: any;
  itemTotalSplit!: any;
  itemTotalTooltip!: any;
  itemTotalLastYear!: any;

  itemQuantity!: any;
  itemQuantityValidation!: any;
  itemQuantitySplit!: any;
  itemQuantityTooltip!: any;
  itemQuantityLastYear!: any;

  loading: boolean = true;
  branchsFilter!: any;
  selersFilter!: any;
  filterChange!: any;
  paramStatus!: any;

  dateFirst!: any;

  constructor(private router: Router, private api: ApiService) { }

  ngOnInit() {
  }

  filterItem(item: any) {
    this.loading = true;
    this.filterChange = item;
    if (item.branch != undefined) {
      this.branchsFilter = item.branch;
      this.selersFilter = item.selers;
      this.paramInformation().subscribe(data => {
        this.paramStatus = data.items[0].value;
      })
      this.saleInformation(item).subscribe(data => {
        try {
          let excelInfo = [];
          let content = data.dataRow;
          this.itemTm = content[0].tm;
          this.itemTmValidation = this.itemTm;
          this.itemTmLastYear = data.dataRowLastYear[0].tm;
          this.itemTm != null
            ? this.itemTmTooltip = 'Ticket médio: ' + parseFloat(this.itemTm).toLocaleString('pt-BR', {minimumFractionDigits: 2 , style: 'currency', currency: 'BRL'})
            : (this.itemTmTooltip = CONSTANTS.MESSAGES.DATA_NULL_TM, this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_TM));
          this.itemTm = parseFloat(this.itemTm);
          this.itemTm = this.itemTm.toLocaleString('pt-br', {maximumFractionDigits: 2});
          excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Tipo': 'Ticket médio', 'Valor': 'R$' + this.itemTm.toString()});
  
          this.itemPmpv = content[0].pmpv;
          this.itemPmpvValidation = this.itemPmpv;
          this.itemPmpvLastYear = data.dataRowLastYear[0].pmpv;
          this.itemPmpv != null
            ? this.itemPmpvTooltip = 'Preço médio por venda: ' + parseFloat(this.itemPmpv).toLocaleString('pt-BR', {minimumFractionDigits: 2 , style: 'currency', currency: 'BRL'})
            : (this.itemPmpvTooltip = CONSTANTS.MESSAGES.DATA_NULL_PMPV, this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_PMPV));
          this.itemPmpv = parseFloat(this.itemPmpv);
          this.itemPmpv = this.itemPmpv.toLocaleString('pt-br', {maximumFractionDigits: 2});
          excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Tipo': 'Preço médio por venda', 'Valor': 'R$' + this.itemPmpv.toString()});
  
          this.itemPa = content[0].pa;
          this.itemPaValidation = this.itemPa;
          this.itemPaLastYear = data.dataRowLastYear[0].pa;
          this.itemPa != null
            ? this.itemPaTooltip = 'Peça por atendimento: ' + parseFloat(this.itemPa).toFixed(2).replace("." , ",")
            : (this.itemPaTooltip = CONSTANTS.MESSAGES.DATA_NULL_PA, this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_PA));
          this.itemPa = parseFloat(this.itemPa);
          this.itemPa = this.itemPa.toLocaleString('pt-br', {maximumFractionDigits: 2});
          excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Tipo': 'Peça por atendimento', 'Valor': this.itemPa.toString()});
  
          this.itemTotal = content[0].invoice_value;
          this.itemTotalValidation = this.itemTotal;
          this.itemTotalLastYear = data.dataRowLastYear[0].invoice_value;
          this.itemTotal != null
            ? this.itemTotalTooltip = 'Total de vendas: ' + parseFloat(this.itemTotal).toLocaleString('pt-BR', {minimumFractionDigits: 2 , style: 'currency', currency: 'BRL'})
            : (this.itemTotalTooltip = CONSTANTS.MESSAGES.DATA_NULL_TOTAL, this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_TOTAL));
          this.itemTotal = parseFloat(this.itemTotal);
          this.itemTotal = this.itemTotal.toLocaleString('pt-br', {maximumFractionDigits: 2});
          excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Tipo': 'Total de vendas', 'Valor': 'R$' + this.itemTotal.toString()});

          this.itemQuantity = content[0].itens_qty || 0;
          this.itemQuantityValidation = this.itemQuantity;
          this.itemQuantityLastYear = data.dataRowLastYear[0].itens_qty || 0;
          this.itemQuantity != null
            ? this.itemQuantityTooltip = 'Quantidade de peças: ' + parseFloat(this.itemQuantity).toLocaleString('pt-BR', {minimumFractionDigits: 0})
            : (this.itemQuantityTooltip = 'Sem informação de quantidade', this.formatErrorMensagem('Sem informação de quantidade'));
          this.itemQuantity = parseFloat(this.itemQuantity);
          this.itemQuantity = this.itemQuantity.toLocaleString('pt-br', {maximumFractionDigits: 0});
          excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Tipo': 'Quantidade de peças', 'Valor': this.itemQuantity.toString()});
  
          excelInfo.unshift({});
          localStorage.setItem('informative', JSON.stringify(excelInfo));
          this.loading = false;
          this.exibitionItem(); 
          this.calcPorcent(data.dataRow[0], data.dataRowLastYear[0]);
        } catch (error: unknown) {
          this.clearInfo();
          this.loading = false;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
      }, error => {
        this.clearInfo();
        this.loading = false;
        this.formatErrorMensagem(error.message);
      })
    }
  }

  calcPorcent(year: any, lastYear: any) {
    if (year && lastYear) {
      let subPmpv = (year.pmpv - lastYear.pmpv);
      let dividedPmpv = subPmpv / lastYear.pmpv;
      let resultPmpv = dividedPmpv * 100;
      lastYear.pmpv !== 0
        ? this.itemPmpvLastYear = resultPmpv.toFixed(2)
        : this.itemPmpvLastYear = 0;

      let subTm = (year.tm - lastYear.tm);
      let dividedTm = subTm / lastYear.tm;
      let resultTm = dividedTm * 100;
      lastYear.tm !== 0
        ? this.itemTmLastYear = resultTm.toFixed(2)
        : this.itemTmLastYear = 0;

      let subPa = (year.pa - lastYear.pa);
      let dividedPa = subPa / lastYear.pa;
      let resultPa = dividedPa * 100;
      lastYear.pa !== 0
        ? this.itemPaLastYear = resultPa.toFixed(2)
        : this.itemPaLastYear = 0;
      
      let subTotal = (year.invoice_value - lastYear.invoice_value);
      let dividedTotal = subTotal / lastYear.invoice_value;
      let resultTotal = dividedTotal * 100;
      lastYear.invoice_value !== 0
      ? this.itemTotalLastYear = resultTotal.toFixed(2)
      : this.itemTotalLastYear = 0;

      let yearQuantity = year.itens_qty || 0;
      let lastYearQuantity = lastYear.itens_qty || 0;
      let subQuantity = (yearQuantity - lastYearQuantity);
      let dividedQuantity = subQuantity / lastYearQuantity;
      let resultQuantity = dividedQuantity * 100;
      lastYearQuantity !== 0
      ? this.itemQuantityLastYear = resultQuantity.toFixed(2)
      : this.itemQuantityLastYear = 0;
    }
  }

  isNumber(value: any) {
    let parse = Number(value);
    return Number.isNaN(parse);
  }

  clearInfo() {
    this.itemTmValidation = null;
    this.itemPmpvValidation = null;
    this.itemPaValidation = null;
    this.itemTotalValidation = null;
    this.itemQuantityValidation = null;
    this.itemTmTooltip = CONSTANTS.MESSAGES.DATA_ERRO_TM;
    this.itemPmpvTooltip = CONSTANTS.MESSAGES.DATA_ERRO_PMPV;
    this.itemPaTooltip = CONSTANTS.MESSAGES.DATA_ERRO_PA;
    this.itemTotalTooltip = CONSTANTS.MESSAGES.DATA_ERRO_TOTAL;
    this.itemQuantityTooltip = 'Erro ao carregar quantidade';
  }

  saleInformation(item: any): Observable<any> {
    return this.api.postTotals(item.dataMin, item.dataMax, item.branch, item.sellers);
  }

  paramInformation(): Observable<any> {
    return this.api.getParam('CD_TIPOCLAS_EMP_MOP');
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: informative \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

  goToDetail() {
    localStorage.setItem('filterInfoBranchs', JSON.stringify(this.filterChange.branch));
    localStorage.setItem('filterInfoMinDate', JSON.stringify(this.filterChange.dataMin));
    localStorage.setItem('filterInfoMaxDate', JSON.stringify(this.filterChange.dataMax));
    localStorage.setItem('filterInfoSellers', JSON.stringify(this.filterChange.sellers));
    localStorage.setItem('filterClassification', this.paramStatus)
    let dateMin = this.filterChange.dataMin.split(' ');
    let dateMax = this.filterChange.dataMax.split(' ');
    this.paramStatus !== null 
      ? this.changeBreadcrumb(dateMin[0], dateMax[0], 'GROUP') 
      : this.changeBreadcrumb(dateMin[0], dateMax[0], 'FILIAL');
  }

  changeBreadcrumb(minDate:any, maxDate:any, type:any) {
    let salesParams = [{'dateMin': minDate, 'dateMax': maxDate, 'branch': this.branchsFilter, 'selers': this.selersFilter}]
    localStorage.setItem('salesGroupParams', JSON.stringify(salesParams));
    localStorage.setItem('salesFilialParams', JSON.stringify(salesParams))
    if (type === 'GROUP') {
      this.router.navigate(['/sales-group']);
    }
    if (type === 'FILIAL') {
      let breadcrumbLinks = [{ label: 'GESTÃO LOJA', link: '/home/sale' }, { label: 'FILIAIS', link: '/sales-filial' }];
      localStorage.setItem('breadcrumbStatus', JSON.stringify(breadcrumbLinks));
      this.router.navigate(['/sales-filial']);
    }
  }

  exibitionItem() {
    let splitItemTotal = this.itemTotal.split('.');
    if (splitItemTotal.length == 3) {
      this.itemTotalSplit = splitItemTotal[0] + 'M'
    } else if (splitItemTotal.length == 2) {
      this.itemTotalSplit = splitItemTotal[0] + 'K'
    } else {
      this.itemTotalSplit = this.itemTotal;
    }

    let splitItemTm = this.itemTm.split('.');
    if (splitItemTm.length == 3) {
      this.itemTmSplit = splitItemTm[0] + 'M'
    } else if (splitItemTm.length == 2) {
      this.itemTmSplit = splitItemTm[0] + 'K'
    } else {
      this.itemTmSplit = this.itemTm;
    }

    let splitItemPmpv = this.itemPmpv.split('.');
    if (splitItemPmpv.length == 3) {
      this.itemPmpvSplit = splitItemPmpv[0] + 'M'
    } else if (splitItemPmpv.length == 2) {
      this.itemPmpvSplit = splitItemPmpv[0] + 'K'
    } else {
      this.itemPmpvSplit = this.itemPmpv;
    }

    let splitItemQuantity = this.itemQuantity.split('.');
    if (splitItemQuantity.length == 3) {
      this.itemQuantitySplit = splitItemQuantity[0] + 'M'
    } else if (splitItemQuantity.length == 2) {
      this.itemQuantitySplit = splitItemQuantity[0] + 'K'
    } else {
      this.itemQuantitySplit = this.itemQuantity;
    }
  }

}
